import React, {useEffect, useState} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import {useIntl} from 'react-intl';
import {useNavigate, useParams} from 'react-router-dom';

import {Button, Descriptions, Divider, message, Space, Spin} from 'antd';
import AppPageMetadata from '@crema/core/AppPageMetadata';
import AppsContainer from '@crema/core/AppsContainer';
import AppsHeader from '@crema/core/AppsContainer/AppsHeader';
import AppsContent from '@crema/core/AppsContainer/AppsContent';
import {MedicationTable} from './MedicationTable';
import {findMedicationRequestById} from 'services/MedicationService';
import {handleError} from 'utils/MessageUtils';
import {IoArrowBackOutline} from 'react-icons/all';

const RequestInfo = () => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();
  const {id} = useParams();
  const navigate = useNavigate();

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const [medicationRequest, setMedicationRequest] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id?.length > 0) {
      setLoading(true);
      findMedicationRequestById(headers, id)
        .then((res) => setMedicationRequest(res.data))
        .catch((error) => handleError(message, error))
        .finally(() => setLoading(false));
    }
  }, [id]);

  return (
    <>
      <AppPageMetadata title={intl.messages['common.detail']} />
      <AppsContainer fullView type='bottom'>
        <AppsHeader key={'header'}>
          <div className='customer-header'>
            <div className='customer-header-input-view'>
              <Button
                type='primary'
                shape='circle'
                ghost
                icon={<IoArrowBackOutline />}
                onClick={() => navigate(`/health/patient?view=medications`)}
              />
            </div>
          </div>
        </AppsHeader>
        <AppsContent
          key={'content'}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
          }}>
          <Space
            direction='vertical'
            style={{width: '100%', paddingLeft: 10, paddingRight: 10}}>
            <Spin spinning={loading}>
              <Descriptions
                bordered
                title={intl.messages['common.detail']}
                size='middle'
                style={{paddingTop: 10}}>
                <Descriptions.Item
                  label={intl.messages['diagnostic.disease']}
                  span={2}>
                  {medicationRequest?.request?.diagnostic?.disease?.name}
                </Descriptions.Item>
                <Descriptions.Item
                  label={intl.messages['medication.requester']}>
                  {medicationRequest?.requester?.name}
                </Descriptions.Item>
                <Descriptions.Item
                  label={intl.messages['medication.note']}
                  span={3}>
                  {medicationRequest?.note}
                </Descriptions.Item>
              </Descriptions>

              <Divider>{intl.messages['medications']}</Divider>

              {medicationRequest?.id && (
                <MedicationTable
                  request={medicationRequest}
                  setRequest={setMedicationRequest}
                  hasManageAuthority={false}
                />
              )}
            </Spin>
          </Space>
        </AppsContent>
      </AppsContainer>
    </>
  );
};

export default RequestInfo;
